import dayjs from "dayjs";
import { environment } from "../../environments/environment";
import { DATE_FORMAT_CE, DATE_FORMAT_DE, DATE_FORMAT_EN, DATE_FORMAT_HR, DATE_FORMAT_HU, DATE_FORMAT_PL, DATE_FORMAT_RO, DATE_FORMAT_RU, DATE_FORMAT_UK } from "../app.module";
import { LanguagesTwoDigit } from "../consts/languages";

export default class HwUtil {

    /* string helpers */
    public static leftPad(num: number, size: number): string {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    public static truncateString(textToTruncate?: string, len?: number): string {
        if (!textToTruncate)
            return "";

        if (textToTruncate.length <= len) {
            return textToTruncate;
        } else {
            return textToTruncate.substring(0, len) + "...";
        }
    }

    public static areaKindIconPath(areaKind: string): string {
        const baseUrl = "../../../assets/icons/";

        switch (areaKind) {
            case "":
            case null:
                return baseUrl + "star.svg";
            case "SwimmingPool":
                return baseUrl + "uszoda.svg";
            case "AdventurePool":
                return baseUrl + "elmenyfurdo.svg";
            case "Medicine":
                return baseUrl + "gyogyaszat.svg";
            case "Massage":
                return baseUrl + "masszazs.svg";
            case "Wellness":
                return baseUrl + "wellness.svg";
            case "Gymnastics":
                return baseUrl + "torna.svg";
            case "SpaSwimming":
                return baseUrl + "gyogyuszas.svg";
            case "NightAdventurePool":
                return baseUrl + "ejszakai.svg";
            case "Sauna":
                return baseUrl + "szauna.svg";
            case "Sports":
                return baseUrl + "sport.svg";
            case "Playground":
                return baseUrl + "jatszoter.svg";
            default:
                return baseUrl + "star.svg";
        }

    }

    public static DateToISOString(date: Date): string {
        return dayjs(date).format("YYYY-MM-DD")
    }

    public static ConvertDateToDateOnly(dateTime: Date): Date {
        var date = new Date(dateTime.getTime());
        date.setHours(0, 0, 0, 0);
        return date;
    }

    public static getShortPropertyName(fullPropertyName: string): string {
        if (!fullPropertyName)
            return "";

        const propertyArray: string[] = fullPropertyName.split(".");
        return propertyArray[propertyArray.length - 1];
    }

    public static redirectWithoutHistory(url: string) {
        window.location.replace(url);
    }

    public static redirectWithHistory(url: string) {
        window.location.href = url;
    }
}
